import { isMobile } from './device'

export const downloadFile = (blob, filename = 'documento.pdf') => {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.target = '_blank'
  a.rel = 'noopener noreferrer'

  if (isMobile()) {
    a.download = filename
  }

  document.body.appendChild(a)
  a.click()
  a.remove()

  setTimeout(() => URL.revokeObjectURL(url), 60000)
}
